import { Form, Input } from 'decorator-form';

import InputType from 'common/form/InputType';
import { BlockStylesConfig, blockStylesInput } from "../common/BlockStylesConfig";
import { TypographyStylesConfig, typographyStylesInput } from '../common/TypographyStylesConfig';

@Form({title: "Card View Config"})
export default class CardViewConfig {

	@Input({type: InputType.UNIT, title: "Field Spacing"})
	public spacing?: string;

	@Input({type: InputType.UNIT, title: "Minimum Height"})
	public minHeight: string;

	@Input({type: InputType.CSS_TRANSITION, title: "Transition"})
	public transition: string;

	@Input({type: typographyStylesInput, title: "Text Styled"})
	public typography: TypographyStylesConfig;

	@Input({type: blockStylesInput, title: "Default State"})
	public defaultState: BlockStylesConfig;

	@Input({type: blockStylesInput, title: "Hover State"})
	public hoverState: BlockStylesConfig;

	@Input({type: blockStylesInput, title: "Active State"})
	public activeState: BlockStylesConfig;

	@Input({type: InputType.CHECKBOX, title: "Auto-equalize height"})
	public autoResize: boolean;

}



// WEBPACK FOOTER //
// ./src/common/views/card/CardConfig.ts